// extracted by mini-css-extract-plugin
module.exports = {"zero-api-instances":"zero-api-instances-2RIc0","zeroApiInstances":"zero-api-instances-2RIc0"};